const DAY_ORDER = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

export const parseSchedule = (raw) => {
  let schedule;
  try {
    schedule = JSON.parse(raw || '{}');
  } catch (_) {
    return [];
  }
  if (!schedule || typeof schedule !== 'object') {
    return [];
  }

  const rows = Object.keys(schedule).map((day) => {
    const v = schedule[day] || {};
    const candidates = v.closed_noon
      ? [[v.open_morning, v.close_morning], [v.open_afternoon, v.close_night]]
      : [[v.open_morning, v.close_night]];
    const ranges = candidates.filter(([open, close]) => open && close);
    return {day, ranges};
  });

  const allFrenchDays = rows.every(r => DAY_ORDER.indexOf(r.day.toLowerCase()) !== -1);
  if (allFrenchDays) {
    rows.sort((a, b) => DAY_ORDER.indexOf(a.day.toLowerCase()) - DAY_ORDER.indexOf(b.day.toLowerCase()));
  }
  return rows;
};

export const scheduleRowLabel = (ranges) =>
  ranges.map(([open, close]) => `${open} – ${close}`).join(' / ');

const toMinutes = (time) => {
  const parts = String(time).split(':');
  const minutes = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  return isNaN(minutes) ? null : minutes;
};

export const getOpenStatus = (rows, now = new Date()) => {
  const todayKey = DAY_ORDER[(now.getDay() + 6) % 7];
  const today = rows.find(r => r.day.toLowerCase() === todayKey);
  if (!today) {
    return null;
  }
  if (today.ranges.length === 0) {
    return 'closed';
  }
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  const isOpen = today.ranges.some(([open, close]) => {
    const openMin = toMinutes(open);
    const closeMin = toMinutes(close);
    return openMin !== null && closeMin !== null && nowMinutes >= openMin && nowMinutes < closeMin;
  });
  return isOpen ? 'open' : 'closed';
};
